
import Vue from 'vue'
import { api } from '@/services/api';
import { handleLoginCheck } from '@/services/loginChecker';
import MappingManager from '@/components/admin/MappingManager.vue';
import AutoTagRuleManager from '@/components/admin/AutoTagRuleManager.vue';
import BudgetManager from '@/components/admin/BudgetManager.vue';
import DataQualityManager from '@/components/admin/DataQualityManager.vue';
import ImportExportManager from '@/components/admin/ImportExportManager.vue';
import AmazonImportManager from '@/components/admin/AmazonImportManager.vue';
import ApiKeyManager from '@/components/admin/ApiKeyManager.vue';
import AgentManager from '@/components/admin/AgentManager.vue';

type AdminTab = "mappings" | "autoTags" | "budgets" | "dataQuality" | "imports" | "amazon" | "apiKeys" | "agent" | "account";

export default Vue.extend({
    components: {
        MappingManager,
        AutoTagRuleManager,
        BudgetManager,
        DataQualityManager,
        ImportExportManager,
        AmazonImportManager,
        ApiKeyManager,
        AgentManager
    },
    data() {
        return {
            activeTab: "mappings" as AdminTab,
            current: "",
            newPassword: "",
            newUserName: "",
            newUserPassword: "",
            confirm: "",
            error: "",
            tabs: [
                { key: "mappings" as AdminTab, label: "Mappings" },
                { key: "autoTags" as AdminTab, label: "Auto Tags" },
                { key: "budgets" as AdminTab, label: "Budgets" },
                { key: "dataQuality" as AdminTab, label: "Data Quality" },
                { key: "imports" as AdminTab, label: "Import / Export" },
                { key: "amazon" as AdminTab, label: "Amazon" },
                { key: "apiKeys" as AdminTab, label: "API Keys" },
                { key: "agent" as AdminTab, label: "Agent" },
                { key: "account" as AdminTab, label: "Account" }
            ]
        }
    },
    methods: {
        async changePassword() {
            if (this.canChange) {
                const result = await api.changePassword(this.current, this.newPassword);
                if (!result.isOk) {
                    this.error = result.reason;
                } else {
                    this.reset();
                }
            }
        },
        async createUser() {
            const res = await api.createUser(
                this.newUserName,
                this.newUserPassword
            );
            console.log(res);
            if (res) {
                this.newUserName = "";
                this.newUserPassword = "";
            }
        },
        async logout() {
            await api.logout();
            await handleLoginCheck(this.$router);
        },
        async applyBudgetRules() {
            await api.applyBudgetRules([]);
        },
        reset() {
            this.current = "";
            this.newPassword = "";
            this.confirm = "";
            this.error = "";
        }
    },
    computed: {
        canChange(): boolean {
            return this.current.length > 0 && this.newPassword.length > 0 && this.confirm.length > 0 && this.newPassword === this.confirm;
        }
    }
})
